export default __webpack_public_path__ + "static/media/recent.bd155a9d.PNG";